import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import RBALogo from '../../static/logos/RBA_logo.png';
import { Menu, X, ChevronDown, ExternalLink } from 'lucide-react';
import { useLeagueSelection } from '../../hooks/useLeagueSelection';
import './Navbar.css';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isRegionalLigaOpen, setIsRegionalLigaOpen] = useState(false);
    const [isRegionalLigaMobileOpen, setIsRegionalLigaMobileOpen] = useState(false);

    const regioDropdownRef = useRef(null);
    const menuDropdownRef = useRef(null);

    const { leagueLevel, changeLeagueLevel } = useLeagueSelection();


    const toggleRegionalLiga = () => {
        setIsRegionalLigaOpen(!isRegionalLigaOpen);
    }
    const toggleMobileRegionalLiga = () => {
      setIsRegionalLigaMobileOpen(!isRegionalLigaMobileOpen);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (regioDropdownRef.current && !regioDropdownRef.current.contains(event.target)) {
                setIsRegionalLigaOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        {/* Top Black Bar */}
        <div className="top-bar">
          <div className="top-bar-left-content">
          </div>
            <div className="top-bar-right-content">
                <div className="bundes-liga-toggle">
                    <button
                        className={`bundesliga-selector ${leagueLevel === '1' ? 'selected' : ''}`}
                            onClick={() => changeLeagueLevel('1')}>
                        <span>1. Bundesliga</span>
                    </button>
                    <button
                        className={`bundesliga-selector ${leagueLevel === '2' ? 'selected' : ''}`}
                        onClick={() => changeLeagueLevel('2')}>
                        <span>2. Bundesliga</span>
                    </button>
                </div>
                <div className="regional-liga-links" ref={regioDropdownRef}>
                <button className= "regional-liga-links" onClick={ toggleRegionalLiga }>
                    <span>REGIONALLIGA</span>
                    <ChevronDown className={`drop-down-arrow ${isRegionalLigaOpen ? 'rotated' : ''}`}/>
                </button>
                {isRegionalLigaOpen && (
              <div className="regional-liga-links-menu">
                  <Link to="https://nrv-rugby.de/ergebnisse-regionalliga/" target="_blank" rel="noopener noreferrer">
                      <div className="regional-liga-link">
                          Nord
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                  </Link>
                <Link to='https://www.rl-no.de/' target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          Ost
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.clubee.com/hessischerrugbyverbandev/tabellen-27642v4/leagues/12234/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          Südwest
                    <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.clubee.com/rugbyverbandbayernev/regionalliga-267965v4/leagues/2239/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          Bayern
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.rugby.nrw/tabellen-74914v4/leagues/10729/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          NRW
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
              </div>)}
                </div>
            </div>
        </div>

        {/* Logo Overlay */}
        <Link to="/" onClick={() => setIsMenuOpen(false)}>
        <div className="logo-overlay">
            <img src={RBALogo} alt="Rugby Bundesliga Logo" className="logo" />
          <div className="logo-text">
            RUGBY BUNDESLIGA
          </div>
        </div>
        </Link>
        {/* Main Navigation */}
        <div className="main-nav">
          <div className="main-nav-content">
              <div className="main-nav-links">
                <Link to="/neues" className="nav-link nav-link-1">NEUES</Link>
                <Link to="/spiele" className="nav-link nav-link-2">SPIELE</Link>
                <Link to="/tabelle" className="nav-link nav-link-3">TABELLE</Link>
                <Link to="/videos" className="nav-link nav-link-4">VIDEOS</Link>
                <Link to="/ueber" className="nav-link nav-link-5">ÜBER RBA</Link>
              </div>
              <div className="main-nav-right-links">
                  <>
                      <div className="mobile-menu-toggle">
                  {isMenuOpen ?
                      <button
                          onClick={() => setIsMenuOpen(false)} // Explicitly set to false to close
                          aria-label="Close menu"
                      >
                          <X size={24} />
                      </button>
                      :
                      <button
                          onClick={() => setIsMenuOpen(true)} // Explicitly set to true to open
                          aria-label="Open menu"
                      >
                          <Menu size={24} />
                      </button>
                  }
                </div>
                  </>
              </div>
          </div>
        </div>
        {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`} ref={menuDropdownRef}>
        <div className="mobile-menu-links">
            <div className="mobile-bundesliga-toggle">
                <button
                    className={`bundesliga-selector ${leagueLevel === '1' ? 'selected' : ''}`}
                    onClick={() => { changeLeagueLevel('1'); setIsMenuOpen(false) }}>
                    <span>1. Bundesliga</span>
                </button>
                <button
                    className={`bundesliga-selector ${leagueLevel === '2' ? 'selected' : ''}`}
                    onClick={() => { changeLeagueLevel('2'); setIsMenuOpen(false) }}>
                    <span>2. Bundesliga</span>
                </button>
            </div>
            <Link to="/neues" className="mobile-menu-link mobile-link-1" onClick={() => setIsMenuOpen(false)}>NEUES</Link>
            <Link to="/spiele" className="mobile-menu-link mobile-link-2" onClick={() => setIsMenuOpen(false)}>SPIELE</Link>
            <Link to="/tabelle" className="mobile-menu-link mobile-link-3" onClick={() => setIsMenuOpen(false)}>TABELLE</Link>
            <Link to="/videos" className="mobile-menu-link mobile-link-4" onClick={() => setIsMenuOpen(false)}>VIDEOS</Link>
            <Link to="/ueber" className="mobile-menu-link mobile-link-5" onClick={() => setIsMenuOpen(false)}>ÜBER RBA</Link>

            <button className= "regional-liga-mobile-links" onClick={ toggleMobileRegionalLiga }>
                <span>REGIONALLIGA</span>
                <ChevronDown className={`drop-down-arrow ${isRegionalLigaMobileOpen ? 'rotated' : ''}`}/>
            </button>
            {isRegionalLigaMobileOpen && (
                <div className={"regional-liga-mobile-links-menu"}>
                <Link to="https://nrv-rugby.de/ergebnisse-regionalliga/" target="_blank" rel="noopener noreferrer">
                      <div className="regional-liga-link">
                          Nord
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                  </Link>
                <Link to='https://www.rl-no.de/' target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          Ost
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.clubee.com/hessischerrugbyverbandev/tabellen-27642v4/leagues/12234/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                         Südwest 
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.clubee.com/rugbyverbandbayernev/regionalliga-267965v4/leagues/2239/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          Bayern
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
                <Link to="https://www.rugby.nrw/tabellen-74914v4/leagues/10729/seasons/218" target="_blank" rel="noopener noreferrer">
                    <div className="regional-liga-link">
                          NRW
                          <ExternalLink size={22} className="external-link-icon" />
                      </div>
                </Link>
             </div>
            )}
        </div>
      </div>

      </nav>
);
};

export default Navbar;
